// extracted by mini-css-extract-plugin
export default {"wrapper":"QA-z","viewport":"RA-z","container":"SA-z","slide":"TA-z"};